import { lazy, Suspense } from 'react';
import type { RichTextEditorProps } from './rich-text-editor';

// Lazy load RichTextEditor to split `react-quill` from the main bundle
const RichTextEditor = lazy(() => import('./rich-text-editor'));

const RichTextEditorLazy = (props: RichTextEditorProps) => {
  return (
    <Suspense>
      <RichTextEditor {...props} />
    </Suspense>
  );
};

RichTextEditorLazy.displayName = 'RichTextEditorLazy';

export default RichTextEditorLazy;
